import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "calculator" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Intro = _resolveComponent("Intro")
  const _component_Age = _resolveComponent("Age")
  const _component_Situation = _resolveComponent("Situation")
  const _component_Salary = _resolveComponent("Salary")
  const _component_Disability = _resolveComponent("Disability")
  const _component_Work = _resolveComponent("Work")
  const _component_Results = _resolveComponent("Results")
  const _component_Wizard = _resolveComponent("Wizard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Wizard, null, {
      default: _withCtx(() => [
        _createVNode(_component_Intro, { step: 1 }),
        _createVNode(_component_Age, { step: 2 }),
        _createVNode(_component_Situation, { step: 3 }),
        _createVNode(_component_Salary, { step: 4 }),
        _createVNode(_component_Disability, { step: 5 }),
        _createVNode(_component_Work, { step: 6 }),
        _createVNode(_component_Results, { step: 7 })
      ]),
      _: 1
    })
  ]))
}